module.exports = __webpack_public_path__ + "static/media/krt02.4ef60c24.png";